<template>
  <div class="competition-comparison">
    <div class="competition-comparison-container">
        <img class="image-title" src="@/images/investment/star.png">
        <div class="subtext-1">Global market presense</div>
      <h1>
        OOYYO is well positioned for long term success
      </h1>
      <div class="invest-table-comparation-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th>
                <img src="@/images/logo/logo@1x.png" class="img-ooyyo" />
              </th>
              <th>
                <img
                  src="@/images/invest/vroom.png"
                  class="img-vroom img-grey"
                />
              </th>
              <th>
                <img src="@/images/invest/auto1.png" class="img-grey" />
              </th>
              <th>
                <img src="@/images/invest/carvana.png" class="img-grey" />
              </th>
              <th>
                <img src="@/images/invest/truecar.png" class="img-grey" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Market cap./valuation</td>
              <td>Expecting over $1 billion</td>
              <td>$5.8B</td>
              <td>$7.7B</td>
              <td>$51B</td>
              <td>$557M</td>
            </tr>
            <tr>
              <td># of car listing</td>
              <td>10 Million</td>
              <td>20.400</td>
              <td>30.000+</td>
              <td>35.000</td>
              <td>890.000</td>
            </tr>
            <tr>
              <td># of annual website visitors</td>
              <td>10 Million</td>
              <td>195 Million</td>
              <td>105 Million</td>
              <td>13.59 Million</td>
              <td>11.11 Million</td>
            </tr>
            <tr>
              <td># of countries</td>
              <td>27</td>
              <td>United states</td>
              <td>30+</td>
              <td>United States</td>
              <td>United States</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
